import React, { useState, useEffect } from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

const PHOTO_URL = 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=400&h=300&fit=crop&q=80'

export function PhotoFlip({ values = {} }: { values?: FieldValues }) {
  const [flipped, setFlipped] = useState(false)
  const duration = values.duration ?? 0.6
  const perspective = values.perspective ?? 800
  const stiffness = values.stiffness ?? 200
  const damping = values.damping ?? 25

  useEffect(() => {
    const interval = setInterval(() => setFlipped((f) => !f), 3000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex items-center justify-center h-full">
      <div
        style={{ perspective }}
        className="cursor-pointer"
        onClick={() => setFlipped((f) => !f)}
      >
        <motion.div
          animate={{ rotateY: flipped ? 180 : 0 }}
          transition={
            values.useSpring
              ? { type: 'spring', stiffness, damping }
              : { duration, ease: 'easeInOut' }
          }
          style={{ transformStyle: 'preserve-3d' }}
          className="relative w-56 h-40 rounded-xl"
        >
          {/* Front - Photo */}
          <div
            className="absolute inset-0 rounded-xl overflow-hidden shadow-xl"
            style={{ backfaceVisibility: 'hidden' }}
          >
            <img
              src={PHOTO_URL}
              alt="Mountain landscape"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            <div className="absolute bottom-2 left-3">
              <span className="text-white text-xs font-semibold drop-shadow">Click to flip</span>
            </div>
          </div>

          {/* Back - Info */}
          <div
            className="absolute inset-0 rounded-xl bg-gradient-to-br from-slate-800 to-slate-900 shadow-xl flex flex-col items-center justify-center gap-2 p-4"
            style={{ backfaceVisibility: 'hidden', transform: 'rotateY(180deg)' }}
          >
            <svg className="w-6 h-6 text-white/60" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M3.75 21h16.5A2.25 2.25 0 0022.5 18.75V5.25A2.25 2.25 0 0020.25 3H3.75A2.25 2.25 0 001.5 5.25v13.5A2.25 2.25 0 003.75 21z" />
            </svg>
            <span className="text-white text-sm font-semibold">Mountain Vista</span>
            <span className="text-white/50 text-[10px] text-center leading-relaxed">
              Photo from Unsplash<br />3D flip with perspective
            </span>
          </div>
        </motion.div>
      </div>
    </div>
  )
}
